import { Redirect } from "expo-router";
import React from "react";

function HomeScreen() {
  return <Redirect href="/(app)/home" />;
}

export default HomeScreen;
